import React, { Component } from 'react';
import { connect } from 'react-redux'
import setActionMessage from '../../actions/setActionMessage';
import setActionsWindowPopup from '../../actions/setActionsWindowPopup';
var contextId
var UEvents = {
    CLOSEWINDOW: "closeWindow",
    DATATRANSFER: "dataTransfer",
    CLOSEWINDOWANDREFRESH: "closeWindowAndRefresh",
    PROCEDURECOMPLETED: "procedureCompleted",
    PROCEDURECOMPLETEDWITHREFRESH: "procedureCompletedWithRefresh",
    PROCEDURECOMPLETEDWITHMESSAGE: "procedureCompletedWithMessage",
    PROCEDUREFAILEDWITHERROR: "closeWindowAndRefresh",
    PROCEDUREFAILED: "procedureFailed",
    ACTION: "action"

}


class iframe extends React.Component {
    constructor(props) {
        super(props);
        this.handleWindowMessage = this.handleWindowMessage.bind(this);
        this.state = {
        }
    }
    handleWindowMessage(message) {
        var dataFromBDV = JSON.parse(message.data);
            if (UEvents.CLOSEWINDOW === dataFromBDV.mainevent) {
                window.close()
            }
            else if (UEvents.DATATRANSFER === dataFromBDV.mainevent) {
            }
            else if (UEvents.CLOSEWINDOWANDREFRESH === dataFromBDV.mainevent) {
                localStorage.setItem('rememberMe', 'refreshWorkplace');
                window.close()
            }
            else if (UEvents.PROCEDURECOMPLETED === dataFromBDV.mainevent) {
                localStorage.setItem('rememberMe', 'refreshWorkplace');
                window.close()
            }
            else if (UEvents.PROCEDURECOMPLETEDWITHREFRESH === dataFromBDV.mainevent) {
            }
            else if (UEvents.PROCEDURECOMPLETEDWITHMESSAGE === dataFromBDV.mainevent) {
            }
            else if (UEvents.PROCEDUREFAILEDWITHERROR === dataFromBDV.mainevent) {
            }
            else if (UEvents.PROCEDUREFAILED === dataFromBDV.mainevent) {
            }
            else if (UEvents.ACTION === dataFromBDV.mainevent) {
            }
            else {
            }   
       
    }

    componentDidMount() {
        const myIframe = document.getElementById('myIframe')
        window.addEventListener("message", this.handleWindowMessage )
    }
    iframe = (e) => {
        var authToken = localStorage.getItem('authToken')
        var selectedRows = [];
        var selectedContexts = [];
        selectedRows.push( this.props.objectALL )
        selectedContexts.push(this.props.contextSelectionState)
        var selectedContext
        if (this.props.contextSelectionState !== undefined) {
            if (this.props.contextSelectionState[0].root !== undefined) {
                selectedContext = this.props.contextSelectionState
            } else {
                selectedContext = null
            }
        }
        var actionname
        if (this.props.actionsName === undefined) {
            actionname = 'Manage DD Specification'
        } else {
            actionname = this.props.actionsName
        }
        var callerData = {
            ActionName: actionname,
            //ActionName: 'Manage DD Specification',
            ActionId:this.props.actionId,
            Token: authToken,
            Userid: this.props.usedataState,
            RoleId: this.props.roledataId,
            FullName: this.props.userdataFullName,
            User: this.props.userNameData,
            Role: this.props.roledataName,
            TaskId: this.props.taskIdState,
            Task: this.props.taskNameState,
            FolderId: this.props.folderIdState,
            Folder: this.props.folderNameState,
            SelectedRows: this.props.objectALL,
            CurrentRow: null,
          //SelectedContexts: this.props.contextSelectionState,
            SelectedContexts: selectedContext,
            ExtraData: null,
            ObjectIdFieldName: 'id',
            EditMode: 0,
            WindowMode: 0,
            contextTemplateID: this.props.contextTemplateIdState,
            contextselection: this.props.contextSelectionState,
        }
        console.log('callerData')
        console.log(callerData)
        document.getElementById('myIframe').contentWindow.postMessage(callerData, "*");
    }
  
    render() {
        if (this.props.contextSelectionState != undefined) {
            if (this.props.contextSelectionState.length > 1) {
                contextId = null
            } else {
                contextId = this.props.contextSelectionState[0].id
            }
        }
        var urlWbdv = this.props.actionURL
        return (
            <div id="iframe-container">
                <iframe onLoad={this.iframe.bind(this, 'name')} id='myIframe' style={{ width: "100%", height: "100vh" }} src={urlWbdv} />
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        refreshdashboardlist: state.currRefreshDashboardState,
        actionId: state.currActionIdState,
        actionURL: state.currActionUrlState,
        folderViewKey: state.folderDataViewKey,
        taskIdState: state.taskDataId,
        roledataId: state.roleDataId,
        objectId: state.currentObjectID,
        objectALL: state.currentObject,
        usedataState: state.userData,
        userdataFullName: state.userFullData.FullName,
        folderIdState: state.folderDataId,
        dashboardlist: state.currDashboardlistState,
        contextConfig: state.currentContextConfiguration,
        contextTemplateIdState: state.contextTemplateDataId,
        contextSelectionState: state.contextSelection,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        folderExpandCollapse: state.currFolderExpandCollapse,
        taskNameState: state.taskDataName,
        folderNameState: state.folderDataName,
        roledataName: state.roleDataName,
        actionsLocal: state.currActionsLocal,
        actionsName: state.currActionsName,
        userNameData: state.userDataName,

    }
};
const mapDispatchToProps = dispatch => {
    return {
        actionMessageset: payload => dispatch(setActionMessage(payload)),
        actionMessagepopupset: payload => dispatch(setActionsWindowPopup(payload)),
        //actionDashboardlistset: payload => dispatch(setActionDashboardlist(payload)),
        //refreshDashboardlistset: payload => dispatch(setActionRefreshDashboard(payload)),
        //ActionIdset: payload => dispatch(setActionID(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(iframe);






// WEBPACK FOOTER //
// ./src/components/TaskView/iframe.js